import React from 'react';
import hash from '../../helpers/hash';
import { makeStyles } from '@material-ui/styles';


const useStyles = makeStyles(theme => ({

    numberList: props => ({
        ...props.style
    })
}));

export default (props) => {
    const classes = useStyles(props);
    return (
        <div className={classes.numberList}>
            {props.children}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/client/components/NumberList.js